import dayjs from 'dayjs'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'

type PausedContentProps = {
  record: any
  recordDetails?: any
}

const PausedContent = ({ record, recordDetails }: PausedContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  if (!recordDetails) {
    return null
  }

  const pauseDate = recordDetails.pauseDate
    ? dayjs(recordDetails.pauseDate).format('DD-MM-YYYY HH:mm')
    : ''
  const continueDate = recordDetails.continueDate
    ? dayjs(recordDetails.continueDate).format('DD-MM-YYYY HH:mm')
    : ''
  const reason = recordDetails.reason || ''

  return (
    <>
      <InfoRow>
        <Label level={2}>{t('PAUSE_DATE') || 'Pause date'}</Label>
        <Value>{pauseDate} </Value>
      </InfoRow>
      <InfoRow>
        <Label level={2}>{t('CONTINUE_DATE') || 'Continue date'}</Label>
        <Value>{continueDate}</Value>
      </InfoRow>
      {reason && (
        <InfoRow>
          <Label level={2}>{t('REASON') || 'Reason'}</Label>
          <Value>{reason}</Value>
        </InfoRow>
      )}
    </>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`


const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`

export default PausedContent
